import { render, staticRenderFns } from "./CreditManager.vue?vue&type=template&id=f4022970&scoped=true"
import script from "./CreditManager.vue?vue&type=script&lang=js"
export * from "./CreditManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4022970",
  null
  
)

export default component.exports